let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dYILR")).then(() => parcelRequire('b26tT'));